<script setup lang="ts">
import { socialLinks, socialIconPaths } from '../../data/navigation'
</script>

<template>
  <nav class="socials" aria-label="Elsewhere">
    <a
      v-for="link in socialLinks"
      :key="link.name"
      :href="link.href"
      :aria-label="link.ariaLabel"
      :target="link.href.startsWith('http') ? '_blank' : undefined"
      :rel="link.href.startsWith('http') ? 'noopener noreferrer' : undefined"
      class="row"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path :d="socialIconPaths[link.icon]" />
      </svg>
      <span class="name">{{ link.name }}</span>
      <span class="arrow meta" aria-hidden="true">↗</span>
    </a>
  </nav>
</template>

<style scoped>
.socials {
  border-top: 1px solid var(--c-rule);
}
.row {
  display: grid;
  grid-template-columns: 1.1rem 1fr auto;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 0;
  border-bottom: 1px solid var(--c-rule);
  color: var(--c-ink-2);
  transition: color 0.2s ease, padding-left 0.3s var(--ease-out-quint);
}
.row:hover {
  color: var(--c-accent);
  padding-left: 0.35rem;
}
.row svg {
  width: 1.05rem;
  height: 1.05rem;
}
.name {
  color: inherit;
  font-size: 0.95rem;
}
.arrow {
  color: var(--c-ink-3);
}
.row:hover .arrow {
  color: var(--c-accent);
}
</style>
